<template>
  <div class="p-basic">
    <exact-search
      ref="exactSearch"
      :immediate="immediateQuery"
      :update-state="updateState"
      :tenementCode="tenementCode"
      :query-list="queryList"
      :search-height-change="calcHeight"
    />
    <exact-list
      :state="state"
      :table-h="tableH1"
      :handle-add="handleAdd"
      :handle-allocate="handleAllocate"
      :handle-edit="handleEdit"
      :import-data-role="importDataRole"
      :handle-view="handleView"
      :handle-delete="handleDelete"
    />
    <!-- 添加 编辑 详情 -->
    <entity-dialog
      ref="entityDialog"
      :title="entityDlgTitle"
      :module-name="moduleName"
      :visible="entityDlgVis"
      :action="entityDlgActn"
      :entity="state.entity"
      :update-vis="updateEntityDlgVis"
      :handle-save="handleSave"
      :tenementCode="tenementCode"
      :showFlowID="showFlowID"
    />
    <!-- 分配数据角色弹窗 -->
    <allocate-dialog
      :title="allocateBtnName"
      :module-name="moduleName"
      :visible="allocateDlgVis"
      :select-role="selectRole"
      :update-vis="updateAllocateDlgVis"
      :tenementCode="tenementCode"
    />

    <!--批量导入-->
    <import-dialog
      module-name=""
      :visible="dialogBool.val"
      :action="'导入数据角色'"
      :uploadData="uploadData"
      :entity="state.entity"
      :state="state"
      :win-close="() => (dialogBool.val = false)"
      :handle-save="() => {}"
    />
  </div>
</template>

<script>
import PageList from "@/mixins/pageList";
import store from "./store";
import ExactSearch from "./components/exactSearch";
import ExactList from "./components/exactList";
import EntityDialog from "./components/entityDialog";
import AllocateDialog from "./components/allocateDialog";
import importDialog from "@/components/basicDialog/components/importDialog";
import { mapState } from "vuex";
import { async } from "q";
import axios from "axios";
export default {
  name: "dataRole",
  mixins: [PageList],
  components: {
    ExactSearch,
    ExactList,
    EntityDialog,
    AllocateDialog,
    importDialog,
  },
  data() {
    return {
      // store唯一标识
      storeKey: "dataRole",
      // 模块名称
      showFlowID: false,
      moduleName: "数据角色管理",
      allocateDlgVis: false,
      selectRole: undefined,
      immediateQuery: false,
      allocateBtnName: undefined,
      entityDlgTitle: undefined,
      dialogBool: { val: false },
      uploadData: {},
    };
  },
  created() {
    this.registStore(store);
  },
  methods: {
    // 分配菜单角色按钮事件
    handleAllocate(val, btnName) {
      if (!val) {
        this.$message.error(this.$t('language.5o6u1qna4xk0'));
        return;
      }
      this.allocateDlgVis = true;
      this.selectRole = val;
      this.allocateBtnName = btnName;
    },
    updateAllocateDlgVis(bool) {
      this.allocateDlgVis = bool;
    },
    handleAdd(btnName) {
      axios({
        method: "post",
        url: "/dataRole/showFlowId",
        data: {
          data: {
            tenementCode: this.tenementCode,
            appCode: "",
          },
        },
        params:{
          tenementCode:this.tenementCode
        }
      })
        .then((resolve) => {
          console.log(" resolve.data.success", resolve.data.success);
          this.showFlowID = resolve.data.success;
          // this.showFlowID = true;
          this.entityDlgVis = true;
          this.entityDlgActn = "add";
          this.entityDlgTitle = btnName;
          this.updateState("entity");
        })
        .catch((reject) => {
          console.log("postBlurryQueryOrgData 请求失败", reject);
        });
    }, // 编辑
    handleEdit(params, btnName, flag) {
      if (_.isEmpty(params)) {
        this.$message.error(`${this.$t('language.5o6u1qna4xk0')}`);
        return;
      }
      if (flag) {
        axios({
          method: "post",
          url: "/dataRole/showFlowId",
          data: {
            data: {
              tenementCode: this.tenementCode,
              appCode: "",
            },
          },
          params:{
            tenementCode:this.tenementCode
          }
        })
          .then((resolve) => {
            console.log(resolve);
            this.showFlowID = resolve.data.success;
            // this.showFlowID = true;
            this.dispatch("queryEntity", { params }).then((res) => {
              this.entityDlgVis = true;
              this.entityDlgActn = "edit";
              this.entityDlgTitle = btnName;
            });
          })
          .catch((reject) => {
            console.log("postBlurryQueryOrgData 请求失败", reject);
          });
      } else {
        axios({
          method: "post",
          url: "/dataRole/showFlowId",
          data: {
            data: {
              tenementCode: this.tenementCode,
              appCode: "",
            },
          },
          params:{
            tenementCode:this.tenementCode
          }
        })
          .then((resolve) => {
            console.log(resolve);

            this.showFlowID = resolve.data.success;
            // this.showFlowID = true;
            this.entityDlgVis = true;
            this.entityDlgActn = "edit";
            this.entityDlgTitle = btnName;
            this.updateState({ entity: params });
          })
          .catch((reject) => {
            console.log("postBlurryQueryOrgData 请求失败", reject);
          });
      }
    },
    // 导入
    importDataRole() {
      this.dialogBool.val = true;
      this.uploadData = {
        uploadUrl: "/dataRole/importDataRole.do",
        templateType: "dataRole",
        name: "dataRoleFile",
      };
    },

    handleView(params, btnName, flag) {
      if (_.isEmpty(params)) {
        this.$message.error(`${this.$t('language.5o6u1qna4xk0')}`);
        return;
      }
      this.entityDlgVis = true;
      this.entityDlgActn = "view";
      this.entityDlgTitle = btnName;
      if (flag) {
        this.dispatch("queryEntity", { params });
      } else {
        this.updateState({ entity: params });
      }
    },
    // 删除
    handleDelete(params, msg) {
      if (_.isEmpty(params)) {
        this.$message.error(`${this.$t('language.5o6u1sna4xk0')}`);
        return;
      }
      api.dataRole
        .queryUsersOfDataRole({
          id: params.id,
          tenementCode: this.tenementCode,
        })
        .then(({ code, data, msg }) => {
          let info = `${this.$t('language.5o6u1qna9xk0')}${data}${this.$t('language.5o6u1qn44xk0')}`;
          const done = () => {
            if (this.state.list.length <= 1) {
              this.updateState({ pageIndex: 0 });
            }
            this.queryList();
          };
          this.$confirm(info, `${this.$t('language.5o6u1qm44xk0')}`).then(() => {
            const req = { id: params.id, tenementCode: this.tenementCode };
            this.dispatch("delete", { params: req, done });
          });
        });
    },
    handleSave({ params, type }) {
      const done = () => {
        this.updateEntityDlgVis(false);
        this.queryList();
        this.$refs.entityDialog.queryList();
      };
      if (type === "add") {
        // 新建
        this.dispatch("createEntity", { params, done });
      } else if (type === "edit") {
        // 新建
        // console.log("新建", params);
        // params.isApply = parseInt(params.isApply);
        // console.log("新建2", params);
        this.dispatch("updateEntity", { params, done });
      } else {
        // 更新
        console.log("更新", params);
        this.dispatch("updateEntity", { params, done });
      }
    },
  },
  computed: {
    ...mapState("app", {
      tenementCode: (state) => state.tenementCode,
    }),
  },
};
</script>
